import * as Sentry from '@sentry/browser';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['inputField'];

  declare readonly inputFieldTarget: HTMLInputElement;

  async connect() {
    if (window.SigmaDeviceManager) {
      try {
        const deviceSessionId = await window.SigmaDeviceManager.getSessionToken();
        this.inputFieldTarget.value = deviceSessionId;
      } catch (responseError) {
        Sentry.captureException(new Error('socure_device_risk_error', { cause: responseError }));
      }
    }
  }
}
